import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import type { InputProps } from "ra-core";
import { useIsMobile } from "@/hooks/use-mobile";

import { CompanyQuickCreateDialog } from "./CompanyQuickCreateDialog";

// The company picker on the contact and deal forms. "New company" is its first
// row, always there, and opens a small dialog: creating used to be a row at the
// bottom that only became usable after typing, which nobody found. LCCRM-87.
export const AutocompleteCompanyInput = ({
  validate,
  label,
}: Pick<InputProps, "validate" | "label">) => {
  const isMobile = useIsMobile();

  return (
    <AutocompleteInput
      label={label}
      optionText="name"
      helperText={false}
      create={<CompanyQuickCreateDialog />}
      createLabel="resources.companies.autocomplete.new_company"
      createPosition="top"
      validate={validate}
      modal={isMobile}
    />
  );
};
